// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__PTATd","signatureButtonsRight":"ModalSign_signatureButtonsRight__25VZN"};